<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getLink('')" :class="{active: currentPage === 'main'}">
            <span>{{ $t('lang.menu.search.organic_group.main') }}</span>
        </a>
        <a :href="getLink('?page=domains')" :class="{active: currentPage === 'domains'}">
            <span>{{ $t('lang.menu.search.organic_group.domains') }}</span>
        </a>
        <a :href="getLink('?page=concurents')" :class="{active: currentPage === 'concurents'}">
            <span>{{ $t('lang.menu.search.organic_group.concurents') }}</span>
        </a>
        <a :href="getLink('?page=sitepages')" :class="{active: currentPage === 'sitepages'}">
            <span>{{ $t('lang.menu.search.organic_group.sitepages') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";
import SubmenuGroup from "../mixins/SubmenuGroup";

export default {
    name: "MenuSubmenuOrganicGroup",
    mixins: [SubmenuGroup],
    data() {
        return {
            listenerId: Listeners.TOP_MENU_ORGANIC_GROUP_HOVER,
        };
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>
